export default "__VITE_ASSET__BcVsK$V1__"